"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultErrorsToIgnore = exports.defaultKeysToSanitize = void 0;
exports.defaultKeysToSanitize = [
    /password/i,
    /token/i,
    /secret/i,
    /passwd/i,
    /authorization/i,
    /api_key/i,
    /apikey/i,
    /sentry_dsn/i,
    /access_token/i,
];
exports.defaultErrorsToIgnore = [
    "top.GLOBALS",
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "http://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "http://loading.retry.widdit.com/",
    "atomicFindClose",
    "fb_xd_fragment",
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    "conduitPage",
];
//# sourceMappingURL=defaults.js.map